import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sg-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: false,
})
export class SgPageNotFoundComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
